import create from "zustand";

import { create as createFlow, State as FlowState } from "./flow";

type Store = FlowState;

export const useStore = create<Store>(() => ({
  ...createFlow(),
}));
